module.exports = __webpack_public_path__ + "static/media/albaraka.2010a7fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/albaraka.png
// module id = 272
// module chunks = 0